import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import DownloadService from '../services/DownloadService';
import State from '../State';
import Events from '../Events';
import Analytics from '../services/Analytics';

const DownloadZip = props => {
	const [disabled, setDisabled] = useState(State.files.length <= 0 || State.isUploading());
	const [downloading, setDownloading] = useState(false);
	const { type, onDownloadComplete } = props;
	const downloadLink = useRef(null);

	function onUploading() {
		setDisabled(true);
	}
	function onUploadingDone() {
		setDisabled(false);
	}
	function onFilesDeleted() {
		setDisabled(true);
	}
	async function onDownload() {
		setDisabled(true);
		setDownloading(true);
		try {
			const urls = State.downloadFileUrls;
			const location = await DownloadService.download(urls);
			downloadLink.current.href = location;
			downloadLink.current.click();
			if (typeof onDownloadComplete === 'function') { // undefined for history
				onDownloadComplete(location, null);
			}
			Analytics.onZip();
		} catch (err) {
			onDownloadComplete(null, err);
		}
		setDisabled(false);
		setDownloading(false);
	}
	function getDownloadButtonText() {
		// eslint-disable-next-line no-nested-ternary
		return downloading ? 'Preparing Download ...' : 'Download Zip';
	}
	useEffect(() => {
		Events.OnUploading(onUploading);
		Events.OnUploadingDone(onUploadingDone);
		Events.OnFilesDeleted(onFilesDeleted);
		return () => {
			Events.OnUploading(onUploading, true);
			Events.OnUploadingDone(onUploadingDone, true);
			Events.OnFilesDeleted(onFilesDeleted, true);
		};
	});
	return (
		<div className="download-button">
			<div className="action-name">Download all files</div>
			<Button
				onClick={onDownload}
				disabled={disabled}
				loading={downloading}
				type={type}
				icon={<DownloadOutlined />}
			>
				{getDownloadButtonText()}
			</Button>
			<a className="hidden" ref={downloadLink}>
				Download
			</a>
		</div>
	);
};

export default DownloadZip;



// WEBPACK FOOTER //
// ./src/components/DownloadZip.js